import "./backgroundAnimation.css"

export default function BackgroundAnimation(){

    return(
        <div className='bgAnimation'  >
          <div className='bubbles' style={{zIndex:"100"}}>
            <span style={{"--i":11.16} as React.CSSProperties} ></span>
            <span style={{"--i":12.32 } as React.CSSProperties} ></span>
            <span style={{"--i":24.44} as React.CSSProperties} ></span>
            <span style={{"--i":10.5} as React.CSSProperties} ></span>
            <span style={{"--i":14.6} as React.CSSProperties} ></span>
            <span style={{"--i":23.89} as React.CSSProperties} ></span>
            <span style={{"--i":28.98} as React.CSSProperties} ></span>
            <span style={{"--i":16.77} as React.CSSProperties} ></span>
            <span style={{"--i":19.56} as React.CSSProperties} ></span>
            <span style={{"--i":6.23} as React.CSSProperties} ></span>
            <span style={{"--i":22.33} as React.CSSProperties} ></span>
            <span style={{"--i":25.43} as React.CSSProperties} ></span>
            <span style={{"--i":18.21} as React.CSSProperties} ></span>
            <span style={{"--i":21.21} as React.CSSProperties} ></span>
            <span style={{"--i":15.18} as React.CSSProperties} ></span>
            <span style={{"--i":13.11} as React.CSSProperties} ></span>
            <span style={{"--i":9.42} as React.CSSProperties} ></span>
            <span style={{"--i":21.89} as React.CSSProperties} ></span>
            <span style={{"--i":29.19} as React.CSSProperties} ></span>
            <span style={{"--i":12.12} as React.CSSProperties} ></span>
            <span style={{"--i":19.91} as React.CSSProperties} ></span>
            <span style={{"--i":10.29} as React.CSSProperties} ></span>
            <span style={{"--i":26.79} as React.CSSProperties} ></span>
            <span style={{"--i":23.64} as React.CSSProperties} ></span>
            <span style={{"--i":12.32} as React.CSSProperties} ></span>
            <span style={{"--i":30.66} as React.CSSProperties} ></span>
            <span style={{"--i":14.31} as React.CSSProperties} ></span>
            <span style={{"--i":16.21} as React.CSSProperties} ></span>
            <span style={{"--i":9.41} as React.CSSProperties} ></span>
            <span style={{"--i":17.71 } as React.CSSProperties} ></span>
            <span style={{"--i":21.72} as React.CSSProperties} ></span>
            <span style={{"--i":23.78} as React.CSSProperties} ></span>
            <span style={{"--i":10.29} as React.CSSProperties} ></span>
            <span style={{"--i":16.65} as React.CSSProperties} ></span>
            <span style={{"--i":12.74} as React.CSSProperties} ></span>
            <span style={{"--i":11.39} as React.CSSProperties} ></span>
            <span style={{"--i":18.92} as React.CSSProperties} ></span>
            <span style={{"--i":19.88} as React.CSSProperties} ></span>
            <span style={{"--i":13.96} as React.CSSProperties} ></span>
            <span style={{"--i":23.48} as React.CSSProperties} ></span>
            <span style={{"--i":17.39} as React.CSSProperties} ></span>
            <span style={{"--i":22.21} as React.CSSProperties} ></span>
            <span style={{"--i":11.01} as React.CSSProperties} ></span>
            <span style={{"--i":32.04} as React.CSSProperties} ></span>
            <span style={{"--i":11.17} as React.CSSProperties} ></span>
            <span style={{"--i":23.25} as React.CSSProperties} ></span>
            <span style={{"--i":9.75} as React.CSSProperties} ></span>
            <span style={{"--i":15.25} as React.CSSProperties} ></span>
            <span style={{"--i":16} as React.CSSProperties} ></span>
            <span style={{"--i":21} as React.CSSProperties} ></span>
            <span style={{"--i":13} as React.CSSProperties} ></span>
            <span style={{"--i":21} as React.CSSProperties} ></span>
            <span style={{"--i":17} as React.CSSProperties} ></span>
            <span style={{"--i":19} as React.CSSProperties} ></span>
            <span style={{"--i":12} as React.CSSProperties} ></span>
            <span style={{"--i":13} as React.CSSProperties} ></span>
            <span style={{"--i":10} as React.CSSProperties} ></span>
            <span style={{"--i":22 } as React.CSSProperties} ></span>
            <span style={{"--i":25} as React.CSSProperties} ></span>
            <span style={{"--i":18} as React.CSSProperties} ></span>
            <span style={{"--i":24} as React.CSSProperties} ></span>
            <span style={{"--i":21} as React.CSSProperties} ></span>
            <span style={{"--i":18} as React.CSSProperties} ></span>
            <span style={{"--i":13} as React.CSSProperties} ></span>
            <span style={{"--i":11} as React.CSSProperties} ></span>
            <span style={{"--i":21} as React.CSSProperties} ></span>
            <span style={{"--i":9} as React.CSSProperties} ></span>
            <span style={{"--i":17} as React.CSSProperties} ></span>
            <span style={{"--i":12} as React.CSSProperties} ></span>
            <span style={{"--i":26} as React.CSSProperties} ></span>
            <span style={{"--i":16} as React.CSSProperties} ></span>
            <span style={{"--i":13} as React.CSSProperties} ></span>
            <span style={{"--i":18} as React.CSSProperties} ></span>
            <span style={{"--i":14} as React.CSSProperties} ></span>
            <span style={{"--i":22} as React.CSSProperties} ></span>
            <span style={{"--i":27} as React.CSSProperties} ></span>
            <span style={{"--i":12} as React.CSSProperties} ></span>
            <span style={{"--i":28} as React.CSSProperties} ></span>
            <span style={{"--i":5} as React.CSSProperties} ></span>
            <span style={{"--i":11} as React.CSSProperties} ></span>
            <span style={{"--i":23} as React.CSSProperties} ></span>
            <span style={{"--i":10} as React.CSSProperties} ></span>
            <span style={{"--i":24} as React.CSSProperties} ></span>
            <span style={{"--i":14} as React.CSSProperties} ></span>
            <span style={{"--i":11} as React.CSSProperties} ></span>
            <span style={{"--i":12 } as React.CSSProperties} ></span>
            <span style={{"--i":24} as React.CSSProperties} ></span>
            <span style={{"--i":10} as React.CSSProperties} ></span>
            <span style={{"--i":14} as React.CSSProperties} ></span>
            <span style={{"--i":23} as React.CSSProperties} ></span>
            <span style={{"--i":28} as React.CSSProperties} ></span>
            <span style={{"--i":16} as React.CSSProperties} ></span>
            <span style={{"--i":19} as React.CSSProperties} ></span>
          </div>
      </div>
    )
}